import axios from "axios";

import { LEGALE_API_BASE_URL } from "../../utils/constants";

export const loginRequest = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${LEGALE_API_BASE_URL}/auth/login/`, data)
      .then((res) => resolve(res))
      .catch((e) => reject(e));
  });
};

export const fetchUserDataRequest = (token) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${LEGALE_API_BASE_URL}/auth/profile`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => resolve(res))
      .catch((e) => reject(e));
  });
};
